import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import styles from './app-layout.module.scss';
import { ThreadProvider } from '@/pages/Thread/context/ThreadProvider';
import SEOHelmet from '@/components/SEOHelmet';
import useSession from '@/hooks/useSession';

const AppLayout = () => {
  const { session, orgIndex } = useSession();
  const { organizations } = session;
  const { search } = useLocation();
  if (search.includes('code=') && search.includes('session_state=')) {
    return (
      <Navigate
        to={{
          pathname: '/confirmation',
          search: location.search,
        }}
      />
    );
  }
  return (
    <>
      <SEOHelmet title={`GANNET ✕ ${organizations[orgIndex].name}`} />
      <ThreadProvider>
        <div className={styles['app-layout']}>
          <Navbar />
          <div className={styles['main-content']}>
            <Outlet />
          </div>
        </div>
      </ThreadProvider>
    </>
  );
};

export default AppLayout;
